import Comp from '../../../../../../ManagementApp/wwwroot/client/src/views/components/StorefrontIntegrationSystemConfigCards.vue';
export default Comp;
